import project from './project'
import interfases from './interfases'
import user from './user'
import router from './router'
import projectList from './projectList'
import home from './home'
import doc from './doc'
const stores = {
  project,
  projectList,
  user,
  interfases,
  router,
  home,
  doc
}

export default stores



// WEBPACK FOOTER //
// ./src/store/index.js